import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/Decor_common.png'


const _withScopeId = n => (_pushScopeId("data-v-1b735be2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top view" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "top__decor",
  src: _imports_0
}, null, -1))

import { Ref, onBeforeMount, ref } from 'vue';
import { TopUserItem, TopService } from '@/services/TopService';
import BaseTabs from '@/components/shared/BaseTabs.vue';
import BaseTopUser from '@/components/top/BaseTopUser.vue';
import BaseLoader from '@/components/shared/BaseLoader.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TopView',
  setup(__props) {

const topTodayUsers: Ref<TopUserItem[]> = ref([]);
const top3DaysUsers: Ref<TopUserItem[]> = ref([]);
const top10DaysUsers: Ref<TopUserItem[]> = ref([]);
onBeforeMount(() => {
	TopService.getTop().then((top) => {
		if (top.result === true) {
			topTodayUsers.value = top.daily_top;
			top3DaysUsers.value = top.three_days_top;
			top10DaysUsers.value = top.ten_days_top;
		}
	});
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BaseTabs, { tabs: [
				{ name: 'today', title: 'Сегодня' },
				{ name: '3days', title: '3 дня' },
				{ name: '10days', title: '10 дней' }
			] }, {
      today: _withCtx(() => [
        (topTodayUsers.value.length > 0)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(topTodayUsers.value, (user) => {
              return (_openBlock(), _createBlock(BaseTopUser, {
                key: user.user_id,
                user: {
							id: user.user_id,
							nickname: user.user_nickname,
							avatar: user.user_avatar
						},
                likes: user.likes_count
              }, null, 8, ["user", "likes"]))
            }), 128))
          : (_openBlock(), _createBlock(BaseLoader, {
              key: 1,
              size: "md"
            }))
      ]),
      "3days": _withCtx(() => [
        (top3DaysUsers.value.length > 0)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(top3DaysUsers.value, (user) => {
              return (_openBlock(), _createBlock(BaseTopUser, {
                key: user.user_id,
                user: {
							id: user.user_id,
							nickname: user.user_nickname,
							avatar: user.user_avatar
						},
                likes: user.likes_count
              }, null, 8, ["user", "likes"]))
            }), 128))
          : (_openBlock(), _createBlock(BaseLoader, {
              key: 1,
              size: "md"
            }))
      ]),
      "10days": _withCtx(() => [
        (top10DaysUsers.value.length > 0)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(top10DaysUsers.value, (user) => {
              return (_openBlock(), _createBlock(BaseTopUser, {
                key: user.user_id,
                user: {
							id: user.user_id,
							nickname: user.user_nickname,
							avatar: user.user_avatar
						},
                likes: user.likes_count
              }, null, 8, ["user", "likes"]))
            }), 128))
          : (_openBlock(), _createBlock(BaseLoader, {
              key: 1,
              size: "md"
            }))
      ]),
      _: 1
    }),
    _hoisted_2
  ]))
}
}

})